import { render, staticRenderFns } from "./BulkTrash.vue?vue&type=template&id=73ef2ff2&"
import script from "./BulkTrash.vue?vue&type=script&lang=js&"
export * from "./BulkTrash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports